window.app.controller('partnerRegistrationCtrl', ['$scope', function ($scope) {

    $scope.sendPartnerInfo = () => {
      $scope.partnerInfo.type = 'partner';
        $scope.sendXHR({
            url: '/api/front/registration/registration/register',
            data: $scope.partnerInfo,
            successFunc: $scope.requestSuccess,
            errorFunc: $scope.requestFail
        });
    }

    $scope.requestSuccess = (resp) => {
        if(resp.data.registrationSuccess){
          $scope.registrationSuccess = true;
        }
        else{
            $scope.showAlert('error', resp.data.message)
        }
    }
        
}]);



// WEBPACK FOOTER //
// src/js/controllers/partner/registrationCtrl.js